import { SxProps, Theme } from '@mui/material/styles';

export const useEllipsisStyles = (): SxProps<Theme> => ({
	wordBreak: 'break-all',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	WebkitLineClamp: '2',
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
});
